import { render, staticRenderFns } from "./Inhalt.vue?vue&type=template&id=006c8f1a&scoped=true&"
import script from "./Inhalt.vue?vue&type=script&lang=js&"
export * from "./Inhalt.vue?vue&type=script&lang=js&"
import style0 from "./Inhalt.vue?vue&type=style&index=0&id=006c8f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c8f1a",
  null
  
)

export default component.exports